(() => {
 if(window.__softSkinHomeInstalled){window.__softSkinHomeInit?.();return;}
 window.__softSkinHomeInstalled=true;
 const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
 function init() {
  document.querySelectorAll('.ssh-products').forEach(root=>{
   if(root.dataset.sshReady)return;root.dataset.sshReady='1';
   const buttons=[...root.querySelectorAll('[data-ssh-choice]')];
   const result=root.querySelector('[data-ssh-finder-result]');
   if(!result||!buttons.length)return;
   const copy=result.querySelector('p'),link=result.querySelector('a');
   function select(button,animate=true) {
    buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    copy.textContent=button.dataset.copy||'';
    link.textContent=(button.dataset.label||'')+' →';
    link.href=button.dataset.url||'#shop';
    root.querySelectorAll('.product-card').forEach(card=>card.classList.toggle('recommended',Boolean(button.dataset.product)&&card.dataset.product===button.dataset.product));
    if(animate&&!reduced()){result.classList.remove('changing');void result.offsetWidth;result.classList.add('changing');}
   }
   buttons.forEach(b=>b.addEventListener('click',()=>select(b)));
   select(buttons[0],false);
  });
  document.querySelectorAll('.ssh-proof').forEach(root=>{
   if(root.dataset.sshReady)return;root.dataset.sshReady='1';
   const gallery=root.querySelector('[data-ssh-gallery]'),previous=root.querySelector('[data-ssh-prev]'),next=root.querySelector('[data-ssh-next]');
   if(!gallery||!previous||!next)return;
   const update=()=>{previous.disabled=gallery.scrollLeft<4;next.disabled=gallery.scrollLeft+gallery.clientWidth>=gallery.scrollWidth-4;};
   previous.addEventListener('click',()=>gallery.scrollBy({left:-(gallery.clientWidth+15),behavior:reduced()?'instant':'smooth'}));
   next.addEventListener('click',()=>gallery.scrollBy({left:gallery.clientWidth+15,behavior:reduced()?'instant':'smooth'}));
   gallery.addEventListener('scroll',update,{passive:true});
   new ResizeObserver(update).observe(gallery);
   update();
  });
 }
 window.__softSkinHomeInit=init;
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
